import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getMovementV2PageData } from './api';
import type { MovementV2PageDataErrorCode } from './types';

export const {
	Context: MovementV2PageDataContext,
	Provider: MovementV2PageDataContextProvider,
	useContext: useMovementV2PageData,
	useAsyncData: useMovementV2PageDataFromApi,
	prefetchAsyncData: prefetchMovementV2PageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'MovementV2PageDataContext',
	dataProperty: 'pageData',
	getData: getMovementV2PageData,
	getUniqueId: (slug) => slug,
	errorHandler: pageDataErrorHandler<MovementV2PageDataErrorCode>(),
});
